// eslint-disable-next-line no-inline-comments
const [/*********/, FALSE] = require("../private/arrayOfAllBooleans")
const constant = require("./constant"),
  stubFalse = constant(FALSE)

module.exports = stubFalse